import { render } from "./TruckCard.vue?vue&type=template&id=5f7c0bae"
import script from "./TruckCard.vue?vue&type=script&lang=js"
export * from "./TruckCard.vue?vue&type=script&lang=js"

import "./TruckCard.vue?vue&type=style&index=0&id=5f7c0bae&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__